import { Flex } from 'antd';
import CardDetailButton from '../cardDetailButton/cardDetailButton';
import InteractiveCard from '../common/interactiveCard';
import CardData from '../dashboard/cardData';
import { Divider, Paragraph } from '../Ant';
import { useTranslation } from 'react-i18next';
import { Receive, ShieldTick } from '../icons';
import { IMatterRequest } from '../../interface/matterRequest';
import { ROUTES } from '../../constants/constants';
import { useNavigationStack } from '../../context/NavigationStackContext';
import { cardBorderColorMapping, tagColorMapping } from '../../constants/matterRequest';
import NoteIcons from '../common/NoteIcons';
import { getLocalDateAndTime } from '../../constants/utilityFunctions';

const MatterRequestCard = ({ matterRequest }: { matterRequest: IMatterRequest }) => {
  const { t } = useTranslation();
  const { push } = useNavigationStack();

  const handleMatterRequestDetail = () => {
    push(`${ROUTES.MATTER_REQUEST_DETAIL}/${matterRequest?.id}`);
  };
  return (
    <InteractiveCard
      data-testid="matter-request-card"
      className={`pointer w-full conflict-card ${cardBorderColorMapping[matterRequest?.status]}`}
      onActivate={handleMatterRequestDetail}
    >
      <Flex justify="space-between" align="center" className="pb-10">
        <Flex gap={5} align="center">
          <Flex
            justify="center"
            align="center"
            className={`status-chip ${tagColorMapping[matterRequest?.status]}`}
          >
            {t(`matterRequest:status.${matterRequest?.status}`)}
          </Flex>
          <NoteIcons
            hasImportantNotes={matterRequest?.hasImportantNotes}
            hasNotes={matterRequest?.hasNotes}
          />
        </Flex>
        <Flex className="responsive-spacing " align="center">
          <Paragraph $fontsize="12px" $weight={400} $color="subtitle" $lineheight="18px">
            {getLocalDateAndTime(new Date(matterRequest?.createdOn), true)}
          </Paragraph>
          <CardDetailButton
            onOpen={handleMatterRequestDetail}
            testId="matter-request-card-go-detail"
          />
        </Flex>
      </Flex>
      <Divider className="mb-10" />
      <Flex vertical gap={10}>
        <CardData
          type="matter"
          icon={<Receive />}
          title={t('matterRequest:matterRequest')}
          content={
            matterRequest?.principalCompany?.name ??
            matterRequest?.principalPrivatePerson?.fullName ??
            '-'
          }
          subcontent={matterRequest?.subject ?? '-'}
          contentclass="lineclamp-1"
          subcontentclass="lineclamp-1"
        />
        <CardData
          icon={<ShieldTick />}
          type="transaction"
          title={t('matterRequest:responsiblePerson')}
          content={matterRequest?.responsibleUser?.fullName ?? '-'}
        />
      </Flex>
    </InteractiveCard>
  );
};

export default MatterRequestCard;
